import React from "react";
import { sortListComponent } from "../../../theme/theme";

const SortListComponent = (props) => {
  const { items, item, setItem } = props;
  return (
    <div className="flex flex-col mx-0 flex-wrap tablet:mx-0  tablet:flex-row gap-5  tablet:items-center ">
      <div className="flex center items-center gap-4">
        <h3 className="text-left w-16 tablet:text-center">{"Sort by"}</h3>

        {items.map((listItem) => {
          return (
            <div
              key={listItem}
              className={
                listItem === item
                  ? sortListComponent["sortItemSelected"]
                  : sortListComponent["sortItem"]
              }
              onClick={() => setItem(listItem)}
            >
              {listItem}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SortListComponent;
